import {Text, Spinner} from "@fluentui/react-components"
import ContentCard from "../shared/ContentCard"
import "./styles.css"
import DbService from "../../firebase/DbService"
import {useEffect, useState} from "react"

const Section = (props)=>{
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const onFetch=(res)=>{
        setItems(res)
        setLoading(false)

    }
    useEffect(()=>{
        setLoading(true)
        DbService.getAll(onFetch,props.filter,props.sort ? props.sort : "none")
    },[props.filter])
    return <div className="ms-Grid"> <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3 ms-lg1">          
            </div>
            <div className="ms-Grid-col ms-sm6 ms-lg3">
                
                <div style={{marginTop:"10%"}}>
                    <div className="heading-container" style={{display:props.noHeading?"none":"block"}}> 
                         <Text style={{fontFamily:props.font}} size={700}className="heading" >{props.title}</Text>
                    </div>
                </div>
                <div style={{marginTop:"5vh"}}></div>
                
                
            </div>
            <div className="ms-Grid-col ms-sm3 ms-lg9">          
            </div>
            {/* {[1,2,3].map(x=>{ */}
            {loading ? <div><br/> <Spinner style={{marginTop:"5vh"}} /></div>  :<div className="ms-Grid-row" style={{marginLeft:"8%", marginRigth:"8%"}}>
                    {items.map( (item, index)=>{
                        return (
                            <div> 
                        {/* { index+1 %3 === 0? <div className="ms-Grid-col ms-sm6 ms-lg1"></div>:null} */}
                        <div className="ms-Grid-col ms-sm12 ms-lg3" style={{marginTop:"2.5%", marginRight:"3.5%"}}>
                            <ContentCard {...item} font={props.font} />
                        </div>
                        
                        </div>
                        )
                    })}
            </div>}
            {/* </div>})} */}


            </div>
            
           
            
        </div>
}
export default Section